(function (upp) {
    'use strict';

    /**
     * Directive that changes the color of the element where its applied to the
     * color provided by {@link AppearanceConfigService}. The value assigned to
     * the directive determines the color type to be assigned and should be one
     * of the following:
     * - primary
     * - secondary
     * - hint
     */
    TextColorDirectiveController.$inject = [ '$element', '$scope', 'appearanceApiService', 'appearanceConfigService' ];
    function TextColorDirectiveController($element, $scope, appearanceApiService, appearanceConfigService) {
        var type = $element.attr('text-color');
        var observable;
        if (type === 'primary')
            observable = appearanceConfigService.onPrimaryTextColorChange;
        else if (type === 'secondary')
            observable = appearanceConfigService.onSecondaryTextColorChange;
        else if (type === 'hint')
            observable = appearanceConfigService.onHintTextColorChange;
        else
            throw new Error('Unknown text-color type: ' + type);
        var featureName = type + '_text_color';
        observable = observable.bind(appearanceConfigService);

        // Store last known reference for revert behaviour
        var lastKnownValue = null;
        // Updates the element where the directive is applied for it to reflect the feature values
        var updateView = function() { $element.css('color', lastKnownValue); }
        // Cleans any changes done on the element by this directive
        var cleanView = function() { $element.css('color', ''); }

        var subscriptions = []
        // Subscribe for template changes and remove the changes done if the template does not support this
        subscriptions.push( appearanceConfigService.onTemplateIdChange(function(templateId) {
            appearanceApiService.isFeatureSupportedByTemplate(templateId, featureName)
            .then(function(supported) { supported ? updateView() : cleanView() })
        }) )
        // Update the view when changes happen
        subscriptions.push(  observable(function(color) {
            lastKnownValue = color || '';
            updateView();
        }) )
        // Unsubscribe to everything on destroy for preventing memory leaks
        $scope.$on('$destroy', function() {
            subscriptions.forEach(function(fn) { fn() });
        })
    }

    FontFamilyDirectiveController.$inject = [ '$element', '$scope', 'appearanceApiService', 'appearanceConfigService', 'fontLoaderService' ];
    function FontFamilyDirectiveController($element, $scope, appearanceApiService, appearanceConfigService, fontLoaderService) {
        var featureName = 'font'
        // Store last known reference for revert behaviour
        var lastKnownValue = null;
        // Updates the element where the directive is applied for it to reflect the feature values
        var updateView = function() { $element.css('font-family', lastKnownValue); }
        // Cleans any changes done on the element by this directive
        var cleanView = function() { $element.css('font-family', ''); }

        var subscriptions = []
        // Subscribe for template changes and remove the changes done if the template does not support this
        subscriptions.push( appearanceConfigService.onTemplateIdChange(function(templateId) {
            appearanceApiService.isFeatureSupportedByTemplate(templateId, featureName)
            .then(function(supported) { supported ? updateView() : cleanView() })
        }) )
        // Update the view when changes happen
        subscriptions.push(  appearanceConfigService.onFontChange(function(fontFamily) {
            lastKnownValue = fontFamily || '';
            updateView();
        }) )
        // Unsubscribe to everything on destroy for preventing memory leaks
        $scope.$on('$destroy', function() {
            subscriptions.forEach(function(fn) { fn() });
        })
    }

    ShowBottomNavigationDirectiveController.$inject = [ '$element', '$scope', 'appearanceApiService', 'appearanceConfigService' ];
    function ShowBottomNavigationDirectiveController($element, $scope, appearanceApiService, appearanceConfigService) {
        var isTruthy = function(value) {
            return value === 'true' || value === '1' || value === 1 || value === true;
        }
        var featureName = 'show_bottom_navigation'
        // Store last known reference for revert behaviour
        var lastKnownValue = null;
        // Updates the element where the directive is applied for it to reflect the feature values
        var updateView = function() { $element.css('display', isTruthy(lastKnownValue) ? '' : 'none'); }
        // Cleans any changes done on the element by this directive
        var cleanView = function() { $element.css('display', ''); }

        var subscriptions = []
        // Subscribe for template changes and remove the changes done if the template does not support this
        subscriptions.push( appearanceConfigService.onTemplateIdChange(function(templateId) {
            appearanceApiService.isFeatureSupportedByTemplate(templateId, featureName)
            .then(function(supported) { supported ? updateView() : cleanView() })
        }) )
        // Update the view when changes happen
        subscriptions.push(  appearanceConfigService.onShowBottomNavigationChange(function(show) {
            lastKnownValue = show || '';
            updateView();
        }) )
        // Unsubscribe to everything on destroy for preventing memory leaks
        $scope.$on('$destroy', function() {
            subscriptions.forEach(function(fn) { fn() });
        })
    }

    upp
    .directive('textColor', function() {
        return {
            restrict: 'A',
            controller: TextColorDirectiveController,
        }
    })
    .directive('fontFamily', function() {
        return {
            restrict: 'A',
            controller: FontFamilyDirectiveController,
        }
    })
    .directive('showBottomNavigation', function() {
        return {
            restrict: 'A',
            controller: ShowBottomNavigationDirectiveController,
        }
    })
})(upp);


// WEBPACK FOOTER //
// ./src/app/common/directives/appearance-directive.js